"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const Creation_1 = require("./Creation");
const CreativeFormat_1 = require("./CreativeFormat");
class CreationSet {
    constructor({ id, creativeFormats, creations, creationsByOptimizerId, creationsByOtherAssignedOptimizers, inspectionPassedCreations, amount, additionalAmount, deliveryDueDate, screeningDueDate, deliveryDueDays, expressDueDays, finalizedAt, }) {
        this.toJSON = () => ({
            id: this.id,
            creativeFormats: this.creativeFormats.toJSON(),
            creations: this.creations && this.creations.toJSON(),
            creationsByOptimizerId: this.creationsByOptimizerId && this.creationsByOptimizerId.toJSON(),
            creationsByOtherAssignedOptimizers: this.creationsByOtherAssignedOptimizers && this.creationsByOtherAssignedOptimizers.toJSON(),
            inspectionPassedCreations: this.inspectionPassedCreations && this.inspectionPassedCreations.toJSON(),
            amount: this.amount,
            additionalAmount: this.additionalAmount,
            deliveryDueDate: this.deliveryDueDate && this.deliveryDueDate.toISO(),
            screeningDueDate: this.screeningDueDate && this.screeningDueDate.toISO(),
            deliveryDueDays: this.deliveryDueDays,
            expressDueDays: this.expressDueDays,
            finalizedAt: this.finalizedAt,
        });
        // creative formatを元にpointを返す
        this.getResizeSortedCreativeFormats = () => {
            const sortedCreativeFormats = [];
            const resizeCreativeFormats = this.creativeFormats.filter(creativeFormat => !!creativeFormat.resizeBaseId);
            this.creativeFormats.map(creativeFormat => {
                if (!creativeFormat.resizeBaseId) {
                    sortedCreativeFormats.push(creativeFormat);
                    resizeCreativeFormats.map(resizeCreativeFormat => {
                        if (resizeCreativeFormat.resizeBaseId === creativeFormat.id) {
                            sortedCreativeFormats.push(resizeCreativeFormat);
                        }
                    });
                }
            });
            return sortedCreativeFormats;
        };
        this.id = id;
        this.creativeFormats = creativeFormats;
        this.creations = creations;
        this.creationsByOptimizerId = creationsByOptimizerId;
        this.creationsByOtherAssignedOptimizers = creationsByOtherAssignedOptimizers;
        this.inspectionPassedCreations = inspectionPassedCreations;
        this.amount = amount;
        this.additionalAmount = additionalAmount;
        this.deliveryDueDate = deliveryDueDate;
        this.screeningDueDate = screeningDueDate;
        this.deliveryDueDays = deliveryDueDays;
        this.expressDueDays = expressDueDays;
        this.finalizedAt = finalizedAt;
    }
}
CreationSet.fromJSON = (json) => {
    const { id, creativeFormats, creations, creationsByOptimizerId, creationsByOtherAssignedOptimizers, inspectionPassedCreations, amount, additionalAmount, deliveryDueDate, screeningDueDate, deliveryDueDays, expressDueDays, finalizedAt, } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (!Array.isArray(creativeFormats))
        throw new Error('.creativeFormats must be an array');
    if (creations !== undefined && !Array.isArray(creations))
        throw new Error('.creations must be an array');
    if (creationsByOptimizerId !== undefined && !Array.isArray(creationsByOptimizerId))
        throw new Error('.creationsByOptimizerId must be an array');
    if (creationsByOtherAssignedOptimizers !== undefined && !Array.isArray(creationsByOtherAssignedOptimizers))
        throw new Error('.creationsByOtherAssignedOptimizers must be an array');
    if (inspectionPassedCreations !== undefined && !Array.isArray(inspectionPassedCreations))
        throw new Error('.inspectionPassedCreations must be an array');
    if (!Number.isSafeInteger(amount))
        throw new Error('.amount must be an integer');
    if (additionalAmount !== undefined && !Number.isSafeInteger(additionalAmount))
        throw new Error('.additionalAmount must be an integer');
    const _finalizedAt = finalizedAt ? luxon_1.DateTime.fromISO(finalizedAt) : undefined;
    const _deliveryDueDate = deliveryDueDate ? luxon_1.DateTime.fromISO(deliveryDueDate) : undefined;
    const _screeningDueDate = screeningDueDate ? luxon_1.DateTime.fromISO(screeningDueDate) : undefined;
    return new CreationSet({
        id,
        creativeFormats: immutable_1.List(creativeFormats).map(item => CreativeFormat_1.default.fromJSON(item)),
        creations: immutable_1.List(creations).map(item => Creation_1.default.fromJSON(item)),
        creationsByOptimizerId: immutable_1.List(creationsByOptimizerId).map(item => Creation_1.default.fromJSON(item)),
        creationsByOtherAssignedOptimizers: immutable_1.List(creationsByOtherAssignedOptimizers).map(item => Creation_1.default.fromJSON(item)),
        inspectionPassedCreations: immutable_1.List(inspectionPassedCreations).map(item => Creation_1.default.fromJSON(item)),
        amount,
        additionalAmount,
        deliveryDueDate: _deliveryDueDate,
        screeningDueDate: _screeningDueDate,
        deliveryDueDays,
        expressDueDays,
        finalizedAt: _finalizedAt,
    });
};
exports.default = CreationSet;
